'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ScalesViewport = function ScalesViewport(Sparse) {
  var axisScales = function axisScales(params, data, range) {
    var sparseData = new Sparse(getSparseWidth);

    /**
     * In case when there's no d.m3 or d.m4 use zero (ex. postDepartureMode)
     * @param d
     * @returns {Array}
     */
    var yMin = d3.min(data, function (d) {
      return Math.min(0, d.m1, d.m2, d.m3 || 0, d.m4 || 0);
    });
    var yMax = d3.max(data, function (d) {
      return Math.max(0, d.m1, d.m2, d.m3 || 0, d.m4 || 0);
    });

    // the brush can modify the visible range of elements
    data = data.slice(range[0], range[1]);
    function calculateWidth() {
      var width = params.width;
      var dataLength = data.length;
      if (params.width / dataLength > params.maxGroupWidth) {
        width = params.maxGroupWidth * dataLength;
      }
      return width;
    }
    var width = calculateWidth();
    var offset = (params.width - width) / 2;
    var padding = 0.1;
    var outerPadding = 0.05;
    params.xScaleFactor = sparseData.scaleFactor(data, width);
    params.xRange = sparseData.thickPoints(data, params.xScaleFactor);
    params.xWidth = sparseData.scaleWidth(data, params.xScaleFactor);
    params.xWidthFromLengthOfStay = sparseData.getWidthFromLengthOfStay(data, params.xScaleFactor);
    var x = d3.scale.ordinal().domain(_.map(data, 'lengthOfStay')).rangeBands([offset, width + offset], padding, outerPadding).range(data.map(function (d, i) {
      var rangeWidth = params.xRange(d, i);
      return rangeWidth + offset;
    }).concat([offset + width]));
    var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
    function getSparseWidth(d) {
      return d.gapLength * params.xGapSize || params.xDataSize;
    }
    return {
      xScale: x,
      yScale: y
    };
  };
  return axisScales;
};
ScalesViewport.$inject = ['ChartElementsSparseLengthOfStay'];
module.exports = ScalesViewport;